<template>
    <div />
</template>

<script>
import {
    ROUTES_ADD_RESULTS,
    ROUTES_CALENDAR,
    ROUTES_CHALLENGES,
    ROUTES_CLUB_MEMBERS,
    ROUTES_CREWS_LIST,
    ROUTES_EVENT_OVERVIEW,
    ROUTES_EVENT_ATTENDANCE,
    ROUTES_EQUIPMENT_LIST,
    ROUTES_SESSION_ATTENDANCE,
    ROUTES_SESSION_CREWS,
    ROUTES_SESSION_OVERVIEW,
    ROUTES_SESSION_RESULTS,
    ROUTES_SETTINGS_ACCOUNT,
    ROUTES_SETTINGS_BILLING,
    ROUTES_SETTINGS_BILLING_LICENCE_EXPIRED,
    ROUTES_SETTINGS_EDIT_CLUB,
    ROUTES_SETTINGS_INTEGRATIONS,
    ROUTES_SETTINGS_MY_CLUBS,
    ROUTES_SETTINGS_PRIVACY_SETTINGS,
    ROUTES_SQUADS,
    ROUTES_PROFILE_DRV,
    ROUTES_PROFILE_ERGO_REPORT,
    ROUTES_PROFILE_MORNING_MONITORING,
    ROUTES_PROFILE_NOTES,
    ROUTES_PROFILE_OVERVIEW,
    ROUTES_PROFILE_ROWING_REPORT,
    ROUTES_PROFILE_SETTINGS,
    ROUTES_REPORTS,
    ROUTES_REPORTS_OVERVIEW,
    ROUTES_REPORTS_ERGO,
    ROUTES_REPORTS_ROWING,
    ROUTES_REPORTS_GMT,
    ROUTES_REPORTS_MORNING_MONITORING,
    ROUTES_REPORTS_MM_DAILY,
    ROUTES_REPORTS_MM_INJURY_ILLNESS,
    ROUTES_REPORTS_MM_TRAINING_QUALITY,
    ROUTES_REPORTS_RPE,
    ROUTES_REPORTS_ATTENDANCE,
    ROUTES_REPORTS_KAIZEN_TEAM,
    ROUTES_REPORTS_TRAINING_SUMMARY,
    ROUTES_REPORTS_TEAM_ERGO_SUMMARY,
    ROUTES_REPORTS_STEP_TEST_GROUP,
    ROUTES_REPORTS_STEP_TEST_INDIVIDUAL,
    ROUTES_REPORTS_VO2_TEST_GROUP,
    ROUTES_REPORTS_VO2_TEST_INDIVIDUAL,
    ROUTES_REPORTS_2K_TEST_GROUP,
    ROUTES_REPORTS_2K_TEST_INDIVIDUAL,
    ROUTES_REPORTS_6K_TEST_GROUP,
    ROUTES_REPORTS_6K_TEST_INDIVIDUAL
} from '@/constants/routes';

export default {
    PAGES_WITH_FILTER: [
        ROUTES_ADD_RESULTS,
        ROUTES_CALENDAR,
        ROUTES_CHALLENGES,
        ROUTES_CREWS_LIST,
        ROUTES_CLUB_MEMBERS,
        ROUTES_EVENT_OVERVIEW,
        ROUTES_EVENT_ATTENDANCE,
        ROUTES_EQUIPMENT_LIST,
        ROUTES_SESSION_ATTENDANCE,
        ROUTES_SESSION_CREWS,
        ROUTES_SESSION_OVERVIEW,
        ROUTES_SESSION_RESULTS,
        ROUTES_SETTINGS_ACCOUNT,
        ROUTES_SETTINGS_BILLING,
        ROUTES_SETTINGS_BILLING_LICENCE_EXPIRED,
        ROUTES_SETTINGS_EDIT_CLUB,
        ROUTES_SETTINGS_INTEGRATIONS,
        ROUTES_SETTINGS_MY_CLUBS,
        ROUTES_SETTINGS_PRIVACY_SETTINGS,
        ROUTES_SQUADS,
        ROUTES_PROFILE_DRV,
        ROUTES_PROFILE_ERGO_REPORT,
        ROUTES_PROFILE_MORNING_MONITORING,
        ROUTES_PROFILE_NOTES,
        ROUTES_PROFILE_OVERVIEW,
        ROUTES_PROFILE_ROWING_REPORT,
        ROUTES_PROFILE_SETTINGS,
        ROUTES_REPORTS,
        ROUTES_REPORTS_OVERVIEW,
        ROUTES_REPORTS_ERGO,
        ROUTES_REPORTS_ROWING,
        ROUTES_REPORTS_GMT,
        ROUTES_REPORTS_MORNING_MONITORING,
        ROUTES_REPORTS_MM_DAILY,
        ROUTES_REPORTS_MM_INJURY_ILLNESS,
        ROUTES_REPORTS_MM_TRAINING_QUALITY,
        ROUTES_REPORTS_RPE,
        ROUTES_REPORTS_ATTENDANCE,
        ROUTES_REPORTS_KAIZEN_TEAM,
        ROUTES_REPORTS_TRAINING_SUMMARY,
        ROUTES_REPORTS_TEAM_ERGO_SUMMARY,
        ROUTES_REPORTS_STEP_TEST_GROUP,
        ROUTES_REPORTS_STEP_TEST_INDIVIDUAL,
        ROUTES_REPORTS_VO2_TEST_GROUP,
        ROUTES_REPORTS_VO2_TEST_INDIVIDUAL,
        ROUTES_REPORTS_2K_TEST_GROUP,
        ROUTES_REPORTS_2K_TEST_INDIVIDUAL,
        ROUTES_REPORTS_6K_TEST_GROUP,
        ROUTES_REPORTS_6K_TEST_INDIVIDUAL
    ],

    PAGES_WITH_ACTION_BAR: [
        ROUTES_CLUB_MEMBERS,
        ROUTES_CREWS_LIST,
        ROUTES_EVENT_OVERVIEW,
        ROUTES_EVENT_ATTENDANCE,
        ROUTES_EQUIPMENT_LIST,
        ROUTES_REPORTS_STEP_TEST_GROUP,
        ROUTES_REPORTS_VO2_TEST_GROUP,
        ROUTES_REPORTS_2K_TEST_GROUP,
        ROUTES_REPORTS_6K_TEST_GROUP,
        ROUTES_SESSION_ATTENDANCE,
        ROUTES_SESSION_CREWS,
        ROUTES_SESSION_OVERVIEW,
        ROUTES_SESSION_RESULTS,
        ROUTES_SQUADS,
        ROUTES_CHALLENGES
    ],

    watch: {
        '$route.name': {
            immediate: true,
            handler(route) {
                // Toggle class for filter.
                this.toggleFilterClass(route);

                // Toggle class for action bar.
                this.toggleActionBarClass(route);
            }
        }
    },

    methods: {
        toggleFilterClass(route) {
            this.$nextTick(() => {
                const hasFilter = this.$options.PAGES_WITH_FILTER.includes(route);
                const element = document.getElementById('main-account');

                if (!element) {
                    return;
                }

                if (hasFilter) {
                    element.classList.add('has-filter');
                } else {
                    element.classList.remove('has-filter');
                }
            });
        },

        toggleActionBarClass(route) {
            this.$nextTick(() => {
                const hasFilter = this.$options.PAGES_WITH_ACTION_BAR.includes(route);
                const element = document.getElementById('main-account');

                if (!element) {
                    return;
                }

                if (hasFilter) {
                    element.classList.add('has-action-bar');
                } else {
                    element.classList.remove('has-action-bar');
                }
            });
        }
    }
};
</script>
